'use client';

import { __spreadArray, __assign, __awaiter, __generator } from '../_virtual/_tslib.js';
import React__default, { forwardRef, useState, useRef, useEffect, useImperativeHandle, useCallback } from 'react';
import ReactDOM from 'react-dom';
import SingleCheckBox from '../SingleCheckBox/index.js';
import { Container, SelectContainer, SelectWrapper, SelectPlaceholder, SelectIcon, DropdownWrapper, Dropdown, DropdownHeader, SearchBox, SearchInput, SearchRemoveIcon, NotificationBox, LimitText, ClearAllText, DropdownBody, OptionsContainer, DropdownFooter, ApplyBox, SelectItem, SelectItemIcon, DropdownDialog, DialogHeader, DialogBody, OptionItem, NoResultText, DialogFooter } from './MultipleSelect.css.js';
import ArrowBackIcon from '../Images/ArrowBackIcon/index.js';
import ArrowDownIcon from '../Images/ArrowDownIcon/index.js';
import CheckTagIcon from '../Images/CheckTagIcon/index.js';
import RemoveFillIcon from '../Images/RemoveFillIcon/index.js';
import Button from '../Button/index.js';
import translations from './translations.js';
import { ELanguage } from '../Utils/constants.js';
import { compareVariable, transformToLatin, sortArray } from '../Utils/helpers.js';
import useFloating from '../hooks/useFloating/index.js';
import useClickAway from '../hooks/useClickAway.js';
import '../hooks/useMakeSearchable/types.js';
import '../services/resumes/types.js';
import useDebounce, { useMountTransition, useDidUpdateEffect } from '../Utils/hooks.js';
import SearchIcon from '../Images/SearchIcon/index.js';
import { searchCompanyIndustries } from '../MultipleRadio/services.js';
import { MAX_ADDITIONAL_ITEMS } from '../MultipleRadio/context.js';

var MAX_DISPLAY = 1000;
var MultipleSelect = function (props, ref) {
    var name = props.name, options = props.options, defaultSelect = props.defaultSelect, onChange = props.onChange, onBlur = props.onBlur, _a = props.type, type = _a === void 0 ? 'singleApply' : _a, _b = props.optionsStyle, optionsStyle = _b === void 0 ? { maxHeight: '250px' } : _b, _c = props.dropdownStyle, dropdownStyle = _c === void 0 ? { width: '350px' } : _c, _d = props.dropdownPlacement, dropdownPlacement = _d === void 0 ? 'bottom-start' : _d, dropdownTopPosition = props.dropdownTopPosition, dropdownButton = props.dropdownButton, _e = props.selectType, selectType = _e === void 0 ? 'default' : _e, selectWidth = props.selectWidth, selectMaxWidth = props.selectMaxWidth, selectPlaceholder = props.selectPlaceholder, selectPlaceholderColor = props.selectPlaceholderColor, _f = props.limit, limit = _f === void 0 ? MAX_DISPLAY : _f, limitText = props.limitText, maxDisplay = props.maxDisplay, langCode = props.langCode, _g = props.disabled, disabled = _g === void 0 ? false : _g, _h = props.isMobile, isMobile = _h === void 0 ? false : _h, _j = props.hasError, hasError = _j === void 0 ? false : _j, _k = props.hasSearch, hasSearch = _k === void 0 ? true : _k, _l = props.sortEnable, sortEnable = _l === void 0 ? false : _l, _m = props.sortType, sortType = _m === void 0 ? 'asc' : _m, _o = props.sortKey, sortKey = _o === void 0 ? 'name' : _o, floatingConfig = props.floatingConfig, _p = props.msBaseUrl, msBaseUrl = _p === void 0 ? '' : _p, _q = props.isEnableSearchAPI, isEnableSearchAPI = _q === void 0 ? false : _q, selectLayout = props.selectLayout;
    // convert list value [10, 25] to list option [{id: 10, name: ''}, {id: 25, name: ''}]
    var convertValueToOption = function (newOptions) {
        if (Array.isArray(newOptions)) {
            return newOptions.reduce(function (result, item) {
                var newItem = options.find(function (optionItem) { return compareVariable(item, optionItem.id); });
                if (newItem)
                    return __spreadArray(__spreadArray([], result, true), [newItem], false);
                else
                    return result;
            }, []);
        }
        return [];
    };
    var _r = useState(convertValueToOption(defaultSelect || [])), selectedOptions = _r[0], setSeletedOptions = _r[1]; // all selected option
    var _s = useState([]), selectedOptionsMemo = _s[0], setSeletedOptionsMemo = _s[1]; // groups when <Dropdown> isVisible, click cancel button will change selectedOptions equal selectedOptionsMemo
    var _t = useState(options), displayOptions = _t[0], setDisplayOptions = _t[1]; // options display
    var _u = useState(''), searchQuery = _u[0], setSearchQuery = _u[1]; // search option by label
    var _v = useState(MAX_DISPLAY), maxElementDisplay = _v[0], setMaxElementDisplay = _v[1]; // number of <Select Title> can display
    var _w = useState(false), dropdownDialog = _w[0], setDropdownDialog = _w[1]; // dropdown for responsive
    var _x = useState(false), isDropdownVisible = _x[0], setDropdownVisible = _x[1];
    var wrapperRef = useRef(null);
    var maxOptionDisplay = maxDisplay || maxElementDisplay;
    var _y = useState([]), searchResult = _y[0], setSearchResult = _y[1];
    var debounceKeyword = useDebounce([searchQuery], 300);
    var hasTransitionedIn = useMountTransition(isDropdownVisible, 250); // handle animation when mount/unmount Dropdown
    var searchInputRef = useRef(null);
    var _z = useFloating({
        placement: dropdownPlacement,
        position: (floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.position) || 'absolute',
        config: {
            offset: dropdownTopPosition,
            detectHidden: true,
            useWindowAsFlippingContainer: (floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.useWindowAsFlippingContainer) || false
        }
    }), refs = _z.refs, context = _z.context, FloatingPortal = _z.FloatingPortal;
    var t = function (key) {
        if (langCode === ELanguage.VI) {
            return translations[key] || key;
        }
        else {
            return key;
        }
    };
    var responseSelectedOptions = function (options) {
        var response = {
            value: []
        };
        response.value = options.map(function (item) { return item.id; });
        return response;
    };
    var changeSelectedOptions = function (newOptions) {
        if (!compareVariable(selectedOptions, newOptions)) {
            setSeletedOptions(newOptions);
            setMaxElementDisplay(MAX_DISPLAY);
        }
        // if type is 'singleApply' and not on mobile screen, return response on selected option
        if (type === 'singleApply' && !isMobile)
            onChange(responseSelectedOptions(newOptions));
    };
    var handleRemoveOption = function (option) {
        var newOptions = selectedOptions.filter(function (item) { return item.id !== option.id; });
        changeSelectedOptions(newOptions);
        // if type is 'singleApply', changeSelectedOptions already run onChange callback
        if (type !== 'singleApply')
            onChange(responseSelectedOptions(newOptions));
    };
    var handleOnSelected = function (isChecked, option) {
        if (isChecked) {
            var newOptions = __spreadArray(__spreadArray([], selectedOptions, true), [option], false);
            changeSelectedOptions(newOptions);
        }
        else {
            var newOptions = selectedOptions.filter(function (item) { return item.id !== option.id; });
            changeSelectedOptions(newOptions);
        }
    };
    var handleOnSearch = function (text) {
        var formatText = transformToLatin(text).toLowerCase();
        var newOptions = options.filter(function (item) {
            var formatItemLabel = transformToLatin(item.name).toLowerCase();
            return formatItemLabel.indexOf(formatText) > -1;
        });
        setDisplayOptions(newOptions);
        setSearchQuery(text);
    };
    var handleClickCancel = function () {
        changeSelectedOptions(selectedOptionsMemo);
        setDropdownVisible(false);
        setDropdownDialog(false);
    };
    var handleClickApply = function () {
        if (!compareVariable(selectedOptions, selectedOptionsMemo)) {
            onChange(responseSelectedOptions(selectedOptions));
        }
        setDropdownVisible(false);
        setDropdownDialog(false);
    };
    var handleClickClearAll = function () {
        changeSelectedOptions([]);
    };
    var handleDropdown = function () {
        if (isMobile) {
            setDropdownDialog(true);
        }
        else {
            setDropdownVisible(function (state) { return !state; });
        }
    };
    var getSearchResult = function (keyword) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (keyword === '') {
                        setSearchResult([]);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, searchCompanyIndustries(msBaseUrl, keyword)];
                case 1:
                    response = _b.sent();
                    setSearchResult((_a = response === null || response === void 0 ? void 0 : response.data) !== null && _a !== void 0 ? _a : []);
                    return [2 /*return*/];
            }
        });
    }); };
    useClickAway(function () {
        if (type === 'multipleApply' && isDropdownVisible) {
            changeSelectedOptions(selectedOptionsMemo);
        }
        setDropdownVisible(false);
        onBlur && onBlur();
    }, {
        nodeRefs: [refs.reference, refs.popup]
    });
    // calculate width each element SelectItem, handle display
    useEffect(function () {
        if (refs.reference.current === null) {
            return;
        }
        // const listTitleElement = document.querySelectorAll<HTMLElement>(`[data-id="${`${name}-${nameId}`}"]`)
        var selectElement = refs.reference.current;
        var listTitleElement = (selectElement === null || selectElement === void 0 ? void 0 : selectElement.querySelectorAll("[data-id=\"".concat(name, "\"]"))) || [];
        var arrayTitleElement = Array.from(listTitleElement);
        // 90 is number of width ArrowDownIcon, padding, numberDisplay,...
        var totalWidthLeft = 0;
        if (selectWidth)
            totalWidthLeft = selectWidth - 90;
        if (selectMaxWidth)
            totalWidthLeft = selectMaxWidth - 90;
        if (!selectWidth && !selectMaxWidth && wrapperRef.current)
            totalWidthLeft = wrapperRef.current.offsetWidth - 90 || 0;
        arrayTitleElement.find(function (item, idx) {
            // if first element have width > totalWidthLeft, add ellipsis css\
            if (idx === 0 && totalWidthLeft < item.scrollWidth + 6) {
                // 4 (gap) + 2 (border)
                item.style.textOverflow = 'ellipsis';
                item.style.overflow = 'hidden';
                setMaxElementDisplay(1);
                return true;
            }
            else {
                item.style.textOverflow = 'clip';
                item.style.overflow = 'visible';
            }
            totalWidthLeft -= item.offsetWidth + 4; // 4 is gap width between item
            if (totalWidthLeft < 0) {
                setMaxElementDisplay(idx);
                return true;
            }
            return false;
        });
    }, [selectedOptions, refs.reference]);
    // save groups when <Dropdown> isDropdownVisible
    useEffect(function () {
        if (!isMobile && isDropdownVisible)
            setSeletedOptionsMemo(selectedOptions);
        if (isMobile && dropdownDialog)
            setSeletedOptionsMemo(selectedOptions);
        if (!isDropdownVisible) {
            return;
        }
        searchInputRef.current &&
            searchInputRef.current.focus({
                preventScroll: true
            });
    }, [isDropdownVisible, dropdownDialog, isMobile]);
    // when click outside Dropdown, trigger apply event
    useDidUpdateEffect(function () {
        if (!isDropdownVisible) {
            handleOnSearch(''); // reset search query when dropdown off
        }
    }, [isDropdownVisible]);
    // init display options
    useEffect(function () {
        if (!compareVariable(displayOptions, options))
            setDisplayOptions(__spreadArray([], options, true));
    }, [options]);
    // change selected options from props
    useDidUpdateEffect(function () {
        if (defaultSelect) {
            var newOptions = convertValueToOption(defaultSelect);
            if (!compareVariable(selectedOptions, newOptions)) {
                setSeletedOptions(newOptions);
                setMaxElementDisplay(MAX_DISPLAY);
            }
        }
    }, [defaultSelect, options]);
    // block scroll body when dropdownDialog open
    useEffect(function () {
        if (dropdownDialog) {
            document.body.classList.add('overflow-hidden');
            document.documentElement.classList.add('overflow-hidden');
        }
        if (!dropdownDialog) {
            document.body.classList.remove('overflow-hidden');
            document.documentElement.classList.remove('overflow-hidden');
        }
        return function () {
            document.body.classList.remove('overflow-hidden');
            document.documentElement.classList.remove('overflow-hidden');
        };
    }, [dropdownDialog]);
    /**
     * Allow parent to change selected options. Combine useRef and useImperativeHandle
     *
     * @author Tri, Tran Minh
     * @since 18 Aug, 2022
     * @ref https://stackoverflow.com/questions/37949981/call-child-method-from-parent
     */
    useImperativeHandle(ref, function () { return ({
        onSeletedOptionChange: function (selectOptions) {
            changeSelectedOptions(convertValueToOption(selectOptions));
        },
        selectedOptions: selectedOptions
    }); });
    useEffect(function () {
        if (!debounceKeyword) {
            return;
        }
        getSearchResult(searchQuery);
    }, [debounceKeyword]);
    var renderSelectItem = function () {
        return (React__default.createElement(React__default.Fragment, null,
            selectedOptions.slice(0, maxOptionDisplay).map(function (item) { return (
            // if on mobile screen, not display remove icon and hover animation
            React__default.createElement(SelectItem, { key: String(item.id), "data-id": name, hoverOn: !isMobile, selectLayout: selectLayout === null || selectLayout === void 0 ? void 0 : selectLayout.type },
                item.name,
                !isMobile && (React__default.createElement(SelectItemIcon, { onClick: function (e) {
                        e.stopPropagation(); // not trigger <SelectItem> when click <SelectItemIcon>
                        handleRemoveOption(item);
                    }, selectLayout: selectLayout === null || selectLayout === void 0 ? void 0 : selectLayout.type },
                    React__default.createElement(CheckTagIcon, null))))); }),
            selectedOptions.length - maxOptionDisplay > 0 && maxOptionDisplay < MAX_DISPLAY && (React__default.createElement(SelectItem, { selectLayout: selectLayout === null || selectLayout === void 0 ? void 0 : selectLayout.type },
                "+",
                selectedOptions.length - maxOptionDisplay))));
    };
    var renderDropdownResponsive = function () {
        var bodyNode = typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.querySelector('body'));
        if (bodyNode) {
            return ReactDOM.createPortal(React__default.createElement(DropdownDialog, null,
                React__default.createElement(DialogHeader, null,
                    React__default.createElement(ArrowBackIcon, { onClick: handleClickCancel }),
                    selectedOptions.length > 0 && (React__default.createElement(ClearAllText, { onClick: handleClickClearAll }, t('Clear all')))),
                React__default.createElement(DialogBody, null,
                    hasSearch && (React__default.createElement(SearchBox, null,
                        React__default.createElement(SearchIcon, null),
                        React__default.createElement(SearchInput, { ref: searchInputRef, placeholder: t('Search'), onChange: function (e) { return handleOnSearch(e.target.value); }, value: searchQuery, isDisplayRemoveIcon: searchQuery.length > 0 }),
                        React__default.createElement(SearchRemoveIcon, { onClick: function () { return handleOnSearch(''); }, isDisplay: searchQuery.length > 0 },
                            React__default.createElement(RemoveFillIcon, null)))),
                    limitText && selectedOptions.length >= limit && (React__default.createElement(LimitText, { style: { marginTop: 5 } }, limitText)),
                    !sortEnable &&
                        displayOptions.map(function (item) {
                            var isChecked = selectedOptions.findIndex(function (i) { return i.id === item.id; }) > -1;
                            return (React__default.createElement(OptionItem, { key: JSON.stringify(item.id) + 'mobile' },
                                React__default.createElement(SingleCheckBox, { id: JSON.stringify(item.id), label: item.name, isChecked: isChecked, onChecked: function (e) { return handleOnSelected(e, item); }, disabled: limit ? !isChecked && selectedOptions.length >= limit : false, isLeftCheckbox: true })));
                        }),
                    sortEnable &&
                        sortArray(displayOptions, sortType, sortKey).map(function (item) {
                            var isChecked = selectedOptions.findIndex(function (i) { return i.id === item.id; }) > -1;
                            return (React__default.createElement(OptionItem, { key: JSON.stringify(item.id) + 'mobile' },
                                React__default.createElement(SingleCheckBox, { id: JSON.stringify(item.id), label: item.name, isChecked: isChecked, onChecked: function (e) { return handleOnSelected(e, item); }, disabled: limit ? !isChecked && selectedOptions.length >= limit : false, isLeftCheckbox: true })));
                        }),
                    displayOptions.length === 0 && React__default.createElement(NoResultText, null, t('No result'))),
                React__default.createElement(DialogFooter, null,
                    React__default.createElement(Button, { type: 'default', size: 'md', onClick: handleClickCancel, style: { marginRight: 8 } }, t('Cancel')),
                    React__default.createElement(Button, { type: 'primary', size: 'md', onClick: handleClickApply }, (dropdownButton === null || dropdownButton === void 0 ? void 0 : dropdownButton.primaryText) || t('Search')))), bodyNode);
        }
        else
            return null;
    };
    var getDropdownWidth = useCallback(function () {
        var _a;
        if (context.position === 'fixed') {
            return (_a = refs.reference.current) === null || _a === void 0 ? void 0 : _a.offsetWidth;
        }
        return dropdownStyle.width;
    }, [dropdownStyle.width, context.position, refs.reference]);
    var renderOptionItem = function () {
        var _a, _b;
        var responseOptions = displayOptions;
        if (isEnableSearchAPI && searchResult.length > 0) {
            var responseAPI = [];
            var _loop_1 = function (i) {
                var companyItem = searchResult[i];
                if (!companyItem) {
                    return "continue";
                }
                if (responseAPI.length >= MAX_ADDITIONAL_ITEMS) {
                    return "break";
                }
                var filteredMatch = responseOptions.filter(function (item) { return item.id === companyItem.id; });
                if (filteredMatch.length > 0) {
                    return "continue";
                }
                else {
                    responseAPI.push({
                        id: companyItem.id,
                        name: langCode === ELanguage.VI
                            ? (_a = companyItem === null || companyItem === void 0 ? void 0 : companyItem.attributes) === null || _a === void 0 ? void 0 : _a.nameVi
                            : (_b = companyItem === null || companyItem === void 0 ? void 0 : companyItem.attributes) === null || _b === void 0 ? void 0 : _b.nameEn
                    });
                }
            };
            for (var i = 0; i < searchResult.length; i++) {
                var state_1 = _loop_1(i);
                if (state_1 === "break")
                    break;
            }
            responseOptions = __spreadArray(__spreadArray([], responseOptions, true), responseAPI, true);
        }
        if (sortEnable) {
            responseOptions = sortArray(responseOptions, sortType, sortKey);
        }
        if (responseOptions.length === 0) {
            return React__default.createElement(NoResultText, null, t('No result'));
        }
        return responseOptions.map(function (item) {
            var isChecked = selectedOptions.findIndex(function (i) { return i.id === item.id; }) > -1;
            return (React__default.createElement(OptionItem, { key: JSON.stringify(item.id) + 'mobile' },
                React__default.createElement(SingleCheckBox, { id: JSON.stringify(item.id), label: item.name, isChecked: isChecked, onChecked: function (e) { return handleOnSelected(e, item); }, disabled: limit ? !isChecked && selectedOptions.length >= limit : false, isLeftCheckbox: true })));
        });
    };
    var hasValue = selectedOptions.length > 0;
    return (React__default.createElement(Container, { ref: wrapperRef, "data-id": "multiple-select-".concat(name), style: {
            position: (floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.enablePortal) ? 'static' : 'relative'
        } },
        React__default.createElement(SelectContainer, { ref: refs.setReference, active: isDropdownVisible, onClick: handleDropdown, width: selectWidth, maxWidth: selectMaxWidth, type: selectType, disabled: disabled, hasError: hasError, hasValue: hasValue, selectLayout: selectLayout === null || selectLayout === void 0 ? void 0 : selectLayout.type },
            React__default.createElement(SelectWrapper, null, hasValue ? (renderSelectItem()) : (React__default.createElement(SelectPlaceholder, { style: { color: selectPlaceholderColor } }, selectPlaceholder))),
            React__default.createElement(SelectIcon, null,
                React__default.createElement(ArrowDownIcon, null))),
        (isDropdownVisible || hasTransitionedIn) && (React__default.createElement(FloatingPortal, { enable: floatingConfig === null || floatingConfig === void 0 ? void 0 : floatingConfig.enablePortal },
            React__default.createElement(DropdownWrapper, { style: __assign(__assign({}, dropdownStyle), { position: context.position, left: context.x, top: context.y, width: getDropdownWidth(), display: context.isReferenceHidden ? 'none' : 'block' }), ref: refs.setPopup },
                React__default.createElement(Dropdown, { isVisible: isDropdownVisible, "data-floating-placement": context.placement },
                    React__default.createElement(DropdownHeader, null,
                        hasSearch && (React__default.createElement(SearchBox, { isDisplayRemoveIcon: searchQuery.length > 0 },
                            React__default.createElement(SearchIcon, null),
                            React__default.createElement(SearchInput, { ref: searchInputRef, placeholder: t('Search'), onChange: function (e) { return handleOnSearch(e.target.value); }, value: searchQuery, isDisplayRemoveIcon: searchQuery.length > 0 }),
                            React__default.createElement(SearchRemoveIcon, { onClick: function () { return handleOnSearch(''); }, isDisplay: searchQuery.length > 0 },
                                React__default.createElement(RemoveFillIcon, null)))),
                        React__default.createElement(NotificationBox, { isVisible: selectedOptions.length > 0 },
                            React__default.createElement(LimitText, null, selectedOptions.length >= limit && limitText),
                            searchQuery.length === 0 && (React__default.createElement(ClearAllText, { onClick: handleClickClearAll }, t('Clear all'))))),
                    React__default.createElement(DropdownBody, null,
                        React__default.createElement(OptionsContainer, { style: optionsStyle }, renderOptionItem())),
                    type === 'multipleApply' && (React__default.createElement(DropdownFooter, null,
                        React__default.createElement(ApplyBox, null,
                            React__default.createElement(Button, { type: 'default', size: 'md', onClick: handleClickCancel, style: { marginRight: 8 } }, t('Cancel')),
                            React__default.createElement(Button, { type: 'primary', size: 'md', onClick: handleClickApply }, (dropdownButton === null || dropdownButton === void 0 ? void 0 : dropdownButton.primaryText) || t('Search'))))))))),
        dropdownDialog && renderDropdownResponsive()));
};
var MultipleSelect$1 = forwardRef(MultipleSelect);

export { MultipleSelect$1 as default };
//# sourceMappingURL=index.js.map
